import { Injectable } from '@angular/core';
import { BaseService, Tournament, TournamentApi, TournamentDivision, TournamentTeam } from '@mtgame/core';
import { Observable } from 'rxjs';

const STORE_TEAMS_KEY = 'teams';
const STORE_DIVISIONS_KEY = 'divisions';

@Injectable()
export class LeagueTournamentService extends BaseService {
  private tournamentId: number;

  get teams$(): Observable<TournamentTeam[]> {
    return this.store.get(STORE_TEAMS_KEY);
  }

  get divisions$(): Observable<TournamentDivision[]> {
    return this.store.get(STORE_DIVISIONS_KEY);
  }

  constructor(
    private tournamentApi: TournamentApi,
  ) {
    super();
  }

  async initialize(tournament: Tournament): Promise<void> {
    this.tournamentId = tournament.id;
    await Promise.all([
      this.getDivisions(),
      this.getTeams(),
    ])
  }

  async getTeams(): Promise<TournamentTeam[]> {
    const teams = await this.tournamentApi.getTeams(this.tournamentId, null, true);
    this.store.save(STORE_TEAMS_KEY, teams);
    return teams;
  }

  async getDivisions(): Promise<TournamentDivision[]> {
    const divisions = await this.tournamentApi.getTournamentDivisions(this.tournamentId);
    this.store.save(STORE_DIVISIONS_KEY, divisions);
    return divisions;
  }
}
